/* eslint-disable no-lonely-if */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
import React, { useCallback, useEffect, useState } from 'react';
import { checkPathBetweenShape, getPathBetwenShapes } from '@adactiveasia/adsign-map';
import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import { useStores } from '../use.store';

const DetailCard = observer(({ children, selectedPoi, interactiveRef }) => {
    const { mainStore, mapStore } = useStores();

    const [isSameFloor, setIsSameFloor] = useState(false);
    const [isPathStairs, setIsPathStairs] = useState(false);
    const [isPathInclined, setIsPathInclined] = useState(false);
    const [isPathEscalator, setIsPathEscalator] = useState(false);
    const [isPathLift, setIsPathLift] = useState(false);

    useEffect(() => {
        if (selectedPoi) {
            checkPath(selectedPoi);
        } else {
            resetState();
        }
    }, [selectedPoi, mapStore.currentFreeShape]);

    const resetState = () => {
        setIsSameFloor(false);
        setIsPathStairs(false);
        setIsPathInclined(false);
        setIsPathEscalator(false);
        setIsPathLift(false);
    };

    const checkPath = useCallback(
        async (poi) => {
            if (!mainStore.wayfindingShapeFrom || !mainStore.wayfindingShapeTo)
                return;

            const activeImagePoi =
                poi.firstMedias && poi.firstMedias.length > 0
                    ? poi.firstMedias[0]
                    : '';

            const activeStartImagePoi =
                mainStore.startPoi?.firstMedias &&
                mainStore.startPoi?.firstMedias.length > 0
                    ? mainStore.startPoi?.firstMedias[0]
                    : '';

            const { s3Url } = mainStore.config || {};

            if (activeImagePoi) {
                interactiveRef.current.changeTopImage(
                    mainStore.wayfindingShapeTo._id,
                    `${s3Url}/poi/${activeImagePoi}`
                );
            }

            if (activeStartImagePoi) {
                interactiveRef.current.changeTopImage(
                    mainStore.wayfindingShapeFrom._id,
                    `${s3Url}/poi/${activeStartImagePoi}`
                );
            }

            resetState();

            // postSelectAnalytic(mapStore);

            const [onlyDisabled, notDisabled, stairs, inclined] =
                await Promise.all([
                    checkPathBetweenShape(
                        mapStore,
                        mainStore.wayfindingShapeFrom._id,
                        mainStore.wayfindingShapeTo._id,
                        'only-disabled'
                    ),
                    checkPathBetweenShape(
                        mapStore,
                        mainStore.wayfindingShapeFrom._id,
                        mainStore.wayfindingShapeTo._id,
                        'not-disabled'
                    ),
                    checkPathBetweenShape(
                        mapStore,
                        mainStore.wayfindingShapeFrom._id,
                        mainStore.wayfindingShapeTo._id,
                        'stairs'
                    ),
                    checkPathBetweenShape(
                        mapStore,
                        mainStore.wayfindingShapeFrom._id,
                        mainStore.wayfindingShapeTo._id,
                        'inclined'
                    ),
                ]);

            if (
                mainStore.wayfindingShapeFrom?.floorId ===
                mainStore.wayfindingShapeTo.floorId
            ) {
                setIsSameFloor(true);
            } else {
                if (onlyDisabled) {
                    setIsPathLift(true);
                }
                if (notDisabled) {
                    setIsPathEscalator(true);
                }
                if (stairs) {
                    setIsPathStairs(true);
                }
                if (inclined) {
                    setIsPathInclined(true);
                }
            }
        },
        [mapStore, mainStore]
    );

    const tmtt = async (e, type) => {
        e.preventDefault();
        e.stopPropagation();

        if (mainStore.wayfindingShapeFrom && mainStore.wayfindingShapeTo) {
            mapStore.setExpanded(true);
            mapStore.setActiveFloorId(mainStore.wayfindingShapeTo.floorId);

            // setTimeout(() => {
            //     interactiveRef.current?.cameraFocusOnDirection(
            //         mapStore.directions[0]
            //     );
            // }, 1000);

            if (!type) return;

            [...mapStore.freeShapes, ...mapStore.model3ds].forEach((e) => {
                if (
                    e.topImage &&
                    (e._id !== mainStore.wayfindingShapeFrom._id ||
                        e._id !== mainStore.wayfindingShapeTo._id)
                )
                    interactiveRef.current.changeTopImage(e._id, null);
            });

            try {
                // postGoToAnalytic(mapStore);

                const path = getPathBetwenShapes(
                    mapStore,
                    mainStore.wayfindingShapeFrom,
                    mainStore.wayfindingShapeTo,
                    type
                );

                mapStore.setCurrentFreeShape([
                    mainStore.wayfindingShapeFrom,
                    mainStore.wayfindingShapeTo,
                ]);

                mainStore.resetDirectory();

                [...mapStore.freeShapes, ...mapStore.model3ds]
                    .filter(
                        (shape) =>
                            shape._id !== mainStore.wayfindingShapeFrom._id ||
                            shape._id !== mainStore.wayfindingShapeTo._id
                    )
                    .forEach((e) => {
                        interactiveRef.current.changeTopImage(e._id, null);
                    });

                if (!path) {
                    return;
                }
            } catch (error) {}
        }

        mainStore.resetSearchHistory();
        resetState();
    };

    return (
        <div
            className="relative flex flex-col 
            w-full w-[200px] sm:w-[250px] md:w-[300px] xl:w-[300px] 
            h-fit h-xs:w-[240px] h-sm:w-[250px] h-sm2:w-[300px] h-md:w-[300px] bg-white"
            style={{
                outline: '4px solid rgba(255, 255, 255, 0.24)',
                boxShadow:
                    '0px 40px 30px rgba(0, 0, 0, 0.05), inset 0px 1px 1px rgba(255, 255, 255, 0.6)',
                backdropFilter: 'blur(50px)',
            }}
        >
            {children}

            {selectedPoi && (
                <div className="relative flex items-center h-8 sm:h-10">
                    {isSameFloor && (
                        <button
                            type="button"
                            onClick={(e) => tmtt(e, 'not-disabled')}
                            className="flex items-center justify-center gap-[6px] w-full text-white font-bold text-[8px] sm:text-[10px] md:text-[12px] p-1 h-full !bg-[#FF6200] uppercase tracking-[.12em]"
                        >
                            <p>Get Direction</p>
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.0089 22.272L19.0089 14.272L20.8008 16L12.8008 24L11.0089 22.272Z"
                                    fill="white"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.7352 8.00088L11.0072 9.72888L16.6391 15.2969L18.3672 13.5689L12.7352 8.00088Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    )}
                    {!isSameFloor && (isPathInclined || isPathStairs) && (
                        <button
                            type="button"
                            onClick={(e) => tmtt(e, isPathStairs ? 'stairs' : 'inclined')}
                            className="flex items-center justify-center gap-[6px] w-full text-white font-bold text-[8px] sm:text-[10px] md:text-[12px] h-full !bg-[#FF6200] uppercase tracking-[.12em]"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.0089 22.272L19.0089 14.272L20.8008 16L12.8008 24L11.0089 22.272Z"
                                    fill="white"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.7352 8.00088L11.0072 9.72888L16.6391 15.2969L18.3672 13.5689L12.7352 8.00088Z"
                                    fill="white"
                                />
                            </svg>

                            <p>Get Direction</p>
                        </button>
                    )}

                    {isPathEscalator && !isPathInclined && (
                        <button
                            type="button"
                            onClick={(e) => tmtt(e, isPathStairs ? 'stairs' : 'not-disabled')}
                            className="flex items-center justify-center gap-[6px] w-full text-white font-bold text-[8px] sm:text-[10px] md:text-[12px] h-full !bg-[#FF6200] uppercase tracking-[.12em]"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.0089 22.272L19.0089 14.272L20.8008 16L12.8008 24L11.0089 22.272Z"
                                    fill="white"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.7352 8.00088L11.0072 9.72888L16.6391 15.2969L18.3672 13.5689L12.7352 8.00088Z"
                                    fill="white"
                                />
                            </svg>

                            <p className="text-left">Get Direction</p>
                        </button>
                    )}
                    {isPathLift && (
                        <button
                            type="button"
                            onClick={(e) => tmtt(e, 'only-disabled')}
                            className="flex items-center justify-center gap-[6px] w-full text-white font-bold text-[8px] sm:text-[10px] md:text-[12px] h-full !bg-[#FF8133] uppercase tracking-[.12em]"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M11.0392 24.8656H7.19922V7.26562H11.0392V8.48163H8.41523V23.5856H11.0392V24.8656Z"
                                    fill="white"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M18.9758 24.8656H15.0078V23.5856H17.7599V8.48163H15.0078V7.26562H18.9758V24.8656ZM20.8958 14.8816L19.9999 13.9856L22.3678 11.6176L24.7999 13.9856L23.9038 14.8816L22.3678 13.4096L20.8958 14.8816Z"
                                    fill="white"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M24.8004 17.6351L23.9043 16.7391L22.3684 18.2751L20.8964 16.7391L20.0004 17.6351L22.3684 20.0671L24.8004 17.6351ZM12.3203 24.9311H13.6643V7.20312H12.3203V24.9311Z"
                                    fill="white"
                                />
                            </svg>
                            Lift Access
                        </button>
                    )}
                </div>
            )}
        </div>
    );
});

export default DetailCard;
